var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "clientlisting"
  }, [_c('b-card', [_c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true",
      "title": "Search Filter"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("UAD Reason Type")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.UADReasonArr,
      "placeholder": "Select UAD Reason Type",
      "id": "uadreasontype",
      "append-to-body": true,
      "name": "uadreasontype"
    },
    model: {
      value: (_vm.uadreasontype),
      callback: function($$v) {
        _vm.uadreasontype = $$v
      },
      expression: "uadreasontype"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Consignor Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.consignorNameArr,
      "name": "Consignorname",
      "placeholder": "Select Consignor Name",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true
    },
    model: {
      value: (_vm.Consignorname),
      callback: function($$v) {
        _vm.Consignorname = $$v
      },
      expression: "Consignorname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Hub")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.HubsArr,
      "name": "Hub",
      "placeholder": "Select Hub",
      "label": "hubname",
      "id": "hubname",
      "track-by": "hubid",
      "scroll": true
    },
    on: {
      "select": _vm.selectHub
    },
    model: {
      value: (_vm.selectedHub),
      callback: function($$v) {
        _vm.selectedHub = $$v
      },
      expression: "selectedHub"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.huberr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("UAD Sequence")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bars'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.uadsequenceArr,
      "placeholder": "Select UAD Sequence",
      "id": "uadsequence",
      "append-to-body": true,
      "name": "uadsequence"
    },
    model: {
      value: (_vm.uadsequence),
      callback: function($$v) {
        _vm.uadsequence = $$v
      },
      expression: "uadsequence"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("RAD From Date ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "name": "fromDate",
      "max": _vm.toDate,
      "not-after": _vm.toDate
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "click": function($event) {
        _vm.removedateerr(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.fromerr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("RAD To Date ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "name": "toDate",
      "min": _vm.fromDate,
      "not-before": _vm.fromDate
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "click": function($event) {
        _vm.removedateerr(2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.toerr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("AWB")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-tag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWB),
      expression: "AWB"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('AWB')
    },
    attrs: {
      "type": "text",
      "name": "AWB",
      "id": "AWB",
      "placeholder": "Enter AWB"
    },
    domProps: {
      "value": (_vm.AWB)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchShipment($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AWB = $event.target.value
      }
    }
  }), _vm._v("\n               ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "28rem"
    }
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchShipment
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n                "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.clearForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])])])], 1)], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" UAD Report List")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.totalCount))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "3px",
      "margin-left": "6rem"
    }
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button",
      "title": "Download UAD Report"
    },
    on: {
      "click": _vm.Downloaduadreport
    }
  }, [_vm._v("Download .XLSX")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumn,
      "items": _vm.tableItems,
      "innerTableHeader": _vm.innerTableColumn,
      "isEditHidden": true,
      "offset": _vm.offset
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("UAD Marked by")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("UAD Sequence")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("RAD Cutoff time")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("UAD Cutoff time")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Origin Hub code")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Destination Hub Code")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Destination Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Consignor Name")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.UADList), function(data, index) {
    return [_c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.uadmarkedsequence == null ? 0 : data.uadmarkedsequence))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.radcutoff))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.uadcutoff))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.originhubname) + " (" + _vm._s(data.originhubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubname) + " (" + _vm._s(data.destinationhubid) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientname))])])]
  })], 2)])])])])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e7fcc16","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/configuration/UADReport/UADReport.component.html
// module id = 1399
// module chunks = 3